import { render, staticRenderFns } from "./zhutu.vue?vue&type=template&id=6bb32ef6"
import script from "./zhutu.vue?vue&type=script&lang=js"
export * from "./zhutu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports